
import { useEffect, useState } from 'react';
import { useGetUserQuery } from "context/users/usersApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "context/auth/authSlice";
// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import { LinearProgress } from "@mui/material";
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTube from '@mui/icons-material/YouTube';

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "dashboard/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "dashboard/examples/Navbars/DashboardNavbar";
import Footer from "components/layouts/SimpleFooter";
import ProfileInfoCard from "components/Author/profile/components/ProfileInfoCard";
import ProfilesList from "dashboard/examples/Lists/ProfilesList";

// Overview page components
import Header from "components/Author/profile/components/Header";
import UserInfos from 'components/Author/sections/UserInfos';
// Data
import profilesListData from "components/Author/profile/data/profilesListData";
import FavoriTProductList from "components/Author/profile/components/FavoritProductCard";
import useAlert from 'hooks/useAlert';


function TabPanel(props){
  const { children, value, index,  ...other } = props;
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <MDBox sx={{ p: 1 }}>
          {children}
        </MDBox>
      )}
    </div>
  );
}

function ProfileOverview() {
  const {showAlerts} = useAlert();
  const [tabValue, setTabValue] = useState(0);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const connectedUser = useSelector(selectCurrentUser);

  const {
    data : profile,
    isLoading,
    isError,
    error
  } = useGetUserQuery(connectedUser?.id, {
      refetchOnMountOrArgChange: true,
      skip : connectedUser?.id === undefined
  });

  useEffect(() => {
    /* eslint-disable-next-line */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error,
      color :"error"
    }) : null
  }, [error, isError])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      {isLoading && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
      <Header tabvalue={tabValue} handleSetTabValue={handleSetTabValue} profile={profile} >
        <MDBox mt={5} mb={3}>
          <TabPanel key="panel1"  value={tabValue} index={0}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={8} sx={{ display: "flex" }}>
                <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                {profile && <ProfileInfoCard
                  title="profile information"
                  description={profile.bio || 'Parlez-nous de vous!'}
                  info={{
                    fullName: profile.displayName,
                    mobile: profile.phone,
                    email: profile.email,
                    location: profile.location?.country?.name,
                  }}
                  social={[
                    {
                      link: profile.social?.fb,
                      icon: <FacebookIcon />,
                      color: "facebook",
                    },
                    {
                      link: profile.social?.tweet,
                      icon: <TwitterIcon />,
                      color: "twitter",
                    },
                    {
                      link: profile.social?.insta,
                      icon: <InstagramIcon />,
                      color: "instagram",
                    },
                    {
                      link: profile.social?.ytube,
                      icon: <YouTube />,
                      color: "youtube",
                    },
                  ]}
                  action={{ tooltip: "Edit bio", route:profile.id }}
                  shadow={false}
                />}
              </Grid>
              <Grid item xs={12} lg={4} sx={{ display: "flex" }}>
                <Divider orientation="vertical" sx={{ mx: 0 }} />
                <ProfilesList title="conversations" profiles={profilesListData} shadow={false} />
              </Grid>
            </Grid>
          </TabPanel>
        </MDBox>
        <TabPanel key="panel2" value={tabValue} index={1}>
          <FavoriTProductList connectedUser={connectedUser} showAlerts={showAlerts} />
        </TabPanel>
        <TabPanel key="panel3" value={tabValue} index={2}>
          <UserInfos profile={profile}/>
        </TabPanel>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default ProfileOverview;
